import { Button } from '@mantine/core';

const BreakView = ({ breakLabel, breakLinkClassName, breakHandler }) => {
  return (
    <Button variant="transparent" size="sm" className={breakLinkClassName} role="button" tabIndex="0" onKeyPress={breakHandler}>
      {breakLabel}
    </Button>
  );
};

export default BreakView;
